import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "3",
  "slug": "daily-challenges-same-view-global-competition",
  "title": "Daily Challenges: Compare Guesses on the Same Locations",
  "excerpt": "A shared set of five locations, one daily attempt, and a UTC reset.",
  "date": "2026-03-05",
  "category": "Behind the Scenes",
  "image": "https://images.unsplash.com/photo-1614730321146-b6fa6a46bcb4?w=800&q=80",
  "readTime": "2 min",
  "content": [
    {
      "type": "paragraph",
      "text": "EarthGuessr's Daily Challenge gives players the same five locations for a particular UTC date. You need an account, and the game records one attempt per player for that day. The daily leaderboard compares scores from the shared set."
    },
    {
      "type": "heading",
      "text": "Compare the clues after playing"
    },
    {
      "type": "paragraph",
      "text": "Finish your attempt before discussing the locations with someone who is still playing. Afterwards, compare what each of you noticed: a river bend, a coastline, a field pattern, or a feature that led to the wrong guess."
    },
    {
      "type": "paragraph",
      "text": "A shared set makes that conversation easier than comparing scores from different random locations. It still cannot guarantee equal experience or prevent someone from getting outside help."
    },
    {
      "type": "heading",
      "text": "When the challenge changes"
    },
    {
      "type": "paragraph",
      "text": "The reset follows midnight UTC, so your local reset time depends on your time zone and daylight saving time. Use the countdown shown in the game when planning to play with friends."
    },
    {
      "type": "paragraph",
      "text": "The daily participation streak is separate from Streak mode. One concerns completed daily attempts on consecutive dates; the other concerns rounds within a game."
    },
    {
      "type": "heading",
      "text": "What the fairness controls can do"
    },
    {
      "type": "paragraph",
      "text": "Server-side attempt records and scoring checks help enforce the game rules. They do not make a browser-displayed geographic image secret. A location can be inferred from the imagery or mapping data, so coordinate offsets should not be described as a no-peeking guarantee."
    }
  ],
  "relatedSlugs": [
    "anti-cheat-keeping-leaderboard-fair"
  ]
};
